(function () {
  'use strict';

  var root = document.querySelector('[data-vcp-root]');
  if (!root || root.__vcp) return;
  root.__vcp = true;

  var SECTION = root.getAttribute('data-section-id');
  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var DEBOUNCE_MS = 350;
  var REQUEST_TIMEOUT_MS = 15000;
  var SUBMIT_WAIT_MS = 8000;
  var RECS_WAIT_MS = 2500;
  var NORMALIZE_WAIT_MS = 6000;
  var HEADER_CLEARANCE_PX = 80;
  var BAR_MQ = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;

  var els = {
    form: root.querySelector('[data-vcp-form]'),
    lines: root.querySelector('[data-vcp-lines]'),
    empty: root.querySelector('[data-vcp-empty]'),
    bar: root.querySelector('[data-vcp-bar]'),
    live: root.querySelector('[data-vcp-live]'),
    phone: root.querySelector('[data-vcp-phone]'),
    phoneInput: root.querySelector('[data-vcp-phone-input]'),
    note: root.querySelector('[data-vcp-note]'),
    checkout: root.querySelector('[data-vcp-checkout]')
  };

  var pending = {};
  var inflight = {};
  var removing = {};
  var timer = null;
  var running = false;
  var queue = [];
  var lastCart = readInlineCart();
  var seq = 0;
  var barWanted = false;
  var savedPhone = els.phoneInput ? els.phoneInput.value : null;
  var savedNote = els.note ? els.note.value : null;
  var submitting = false;
  var waiting = false;

  function rows() { return els.lines ? Array.prototype.slice.call(els.lines.querySelectorAll('[data-vcp-row]')) : []; }
  function liveRows() { return rows().filter(function (r) { return !r.classList.contains('is-removing'); }); }
  function keyOf(el) { return el.getAttribute('data-key'); }
  function kindOf(el) { return el.getAttribute('data-kind'); }
  function rowByKey(k) {
    var found = null;
    liveRows().forEach(function (r) { if (keyOf(r) === k) found = r; });
    return found;
  }
  function busyKey(k) { return pending[k] != null || !!inflight[k]; }
  function hasPending() { return !!timer || Object.keys(pending).length > 0; }
  function isIdle() { return !running && !queue.length && !hasPending(); }
  function announce(msg) { if (els.live) { els.live.textContent = ''; els.live.textContent = msg; } }
  function importNode(n) { return document.importNode(n, true); }

  function readInlineCart(scope) {
    var n = (scope || root).querySelector('[data-vcp-cart]');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, reject) {
      setTimeout(function () { reject(new Error('timeout')); }, ms || REQUEST_TIMEOUT_MS);
    })]);
  }

  function hardReload() { window.location.reload(); }

  function sectionsUrl() { return window.location.pathname + window.location.search; }

  function post(path, body) {
    body.sections = [SECTION];
    body.sections_url = sectionsUrl();
    return withTimeout(fetch(BASE + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var err = new Error(data.description || data.message || 'Request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function fetchSection() {
    var u = sectionsUrl();
    u += (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(SECTION);
    return withTimeout(fetch(u, { credentials: 'same-origin', cache: 'no-store' })).then(function (r) {
      if (!r.ok) throw new Error('section ' + r.status);
      return r.text();
    });
  }

  function refresh(force) {
    return fetchSection().then(function (h) { patch(h, force); });
  }

  function enqueue(job) {
    return new Promise(function (resolve) {
      queue.push(function () { return Promise.resolve().then(job).then(resolve, resolve); });
      pump();
    });
  }
  function pump() {
    if (running || !queue.length) return;
    running = true;
    setBusy(true);
    var job = queue.shift();
    job().then(function () {
      running = false;
      if (isIdle()) setBusy(false);
      pump();
    });
  }

  function setBusy(on) {
    root.classList.toggle('is-busy', on);
    root.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  }

  function send(updates, errorKeys) {
    var keys = Object.keys(updates);
    if (!keys.length) return Promise.resolve();
    var mine = ++seq;
    var req = keys.length === 1
      ? post('cart/change.js', { id: keys[0], quantity: updates[keys[0]] })
      : post('cart/update.js', { updates: updates });
    return req.then(function (data) {
      releaseRemovals(updates);
      return apply(data, mine).then(function () { verify(updates, errorKeys || keys); });
    }, function (err) {
      releaseRemovals(updates);
      return recover(err, errorKeys || keys);
    });
  }

  function releaseRemovals(updates) {
    Object.keys(updates).forEach(function (k) { if (updates[k] === 0) delete removing[k]; });
  }

  function apply(data, mine) {
    if (data && data.items) lastCart = data;
    var html = data && data.sections && data.sections[SECTION];
    var done = html ? Promise.resolve().then(function () { patch(html); }) : refresh();
    return done.then(function () { return normalize(lastCart, mine); }, hardReload);
  }

  function verify(updates, errorKeys) {
    if (!lastCart || !lastCart.items) return;
    var byKey = {};
    lastCart.items.forEach(function (i) { byKey[i.key] = i.quantity; });
    var missed = Object.keys(updates).filter(function (k) {
      var want = updates[k];
      var got = byKey[k] == null ? 0 : byKey[k];
      return byKey[k] != null && got !== want;
    });
    if (!missed.length) return;
    var capped = missed.filter(function (k) { return byKey[k] > 0 && updates[k] > byKey[k]; });
    capped.forEach(function (k) {
      var r = rowByKey(k);
      if (r) showErr(r, 'Only ' + byKey[k] + ' available');
    });
    if (capped.length === missed.length) return;
    errorKeys.forEach(function (k) { var r = rowByKey(k); if (r) showErr(r, 'That did not go through. Please try again.'); });
    announce('That did not go through. Please try again.');
  }

  function recover(err, keys) {
    var msg = (err && err.data && (err.data.description || err.data.message)) ||
      (err && err.message === 'timeout' ? 'That is taking too long. Please try again.' : 'That did not go through. Please try again.');
    return refresh(true).then(function () {
      keys.forEach(function (k) { var r = rowByKey(k); if (r) showErr(r, msg); });
      announce(msg);
    }, hardReload);
  }

  function setQty(row, raw) {
    var k = keyOf(row);
    var input = row.querySelector('[data-vcp-qty]');
    var n = Math.floor(Number(raw));
    if (String(raw).trim() === '' || !isFinite(n) || n < 0) {
      if (input) input.value = pending[k] != null ? pending[k] : row.getAttribute('data-qty');
      return;
    }
    if (input) input.value = n;
    if (n === 0) return removeRow(row);
    if (String(n) === row.getAttribute('data-qty') && !busyKey(k)) return;
    pending[k] = n;
    row.classList.add('is-pending');
    clearErr(row);
    setBusy(true);
    clearTimeout(timer);
    timer = setTimeout(flushPending, DEBOUNCE_MS);
  }

  function flushPending() {
    clearTimeout(timer);
    timer = null;
    var batch = pending;
    pending = {};
    var keys = Object.keys(batch);
    if (!keys.length) return Promise.resolve();
    keys.forEach(function (k) { inflight[k] = (inflight[k] || 0) + 1; });
    return enqueue(function () {
      var updates = {};
      keys.forEach(function (k) {
        var row = rowByKey(k);
        if (!row) return;
        updates[k] = batch[k];
        addDependents(row, batch[k], updates);
      });
      return send(updates, keys).then(function () {
        keys.forEach(function (k) { if (!--inflight[k]) delete inflight[k]; });
      });
    });
  }

  function addDependents(row, qty, updates) {
    if (kindOf(row) !== 'product') return;
    var vid = row.getAttribute('data-variant');
    var twin = liveRows().some(function (r) {
      return r !== row && kindOf(r) === 'product' && r.getAttribute('data-variant') === vid && updates[keyOf(r)] !== 0;
    });
    var plans = root.querySelectorAll('[data-vcp-plan][data-covers="' + vid + '"], [data-vcp-row][data-kind="plan"][data-covers="' + vid + '"]');
    if (qty === 0) {
      if (!twin) {
        plans.forEach(function (p) { updates[keyOf(p)] = 0; });
        liveRows().forEach(function (r) {
          if (kindOf(r) === 'gift' && r.getAttribute('data-gift-with') === vid) updates[keyOf(r)] = 0;
        });
      }
      var hadFreight = row.getAttribute('data-freight') === '1';
      var freightLeft = liveRows().some(function (r) {
        return r.getAttribute('data-freight') === '1' && updates[keyOf(r)] !== 0;
      });
      if (hadFreight && !freightLeft) {
        liveRows().forEach(function (r) { if (kindOf(r) === 'liftgate') updates[keyOf(r)] = 0; });
      }
    } else if (!twin && plans.length === 1 && plans[0].getAttribute('data-qty') !== String(qty)) {
      updates[keyOf(plans[0])] = qty;
    }
  }

  function removeRow(row) {
    if (!row || row.classList.contains('is-removing')) return;
    var k = keyOf(row);
    var preview = {};
    preview[k] = 0;
    addDependents(row, 0, preview);
    var gone = Object.keys(preview).filter(function (uk) { return preview[uk] === 0; });

    moveFocusFrom(row, gone);
    gone.forEach(function (uk) {
      delete pending[uk];
      removing[uk] = true;
      var r = rowByKey(uk);
      if (r) collapse(r);
    });
    if (!Object.keys(pending).length) { clearTimeout(timer); timer = null; }
    afterLocalChange();
    announce('Removed from cart');

    enqueue(function () {
      var updates = {};
      gone.forEach(function (uk) { updates[uk] = 0; });
      var liveRow = null;
      rows().forEach(function (r) { if (keyOf(r) === k) liveRow = r; });
      if (liveRow) addDependents(liveRow, 0, updates);
      return send(updates, [k]);
    });
  }

  function removePlan(planEl) {
    if (!planEl || planEl.classList.contains('is-pending')) return;
    planEl.classList.add('is-pending');
    planEl.style.opacity = '.45';
    var k = keyOf(planEl);
    enqueue(function () {
      var updates = {};
      updates[k] = 0;
      return send(updates, []);
    });
  }

  function collapse(row) {
    if (row.classList.contains('is-removing')) return;
    row.style.height = row.getBoundingClientRect().height + 'px';
    void row.offsetHeight;
    row.classList.add('is-removing');
    row.setAttribute('aria-hidden', 'true');
    row.style.height = '0px';
    row.style.minHeight = '0px';
    row.style.paddingTop = '0px';
    row.style.paddingBottom = '0px';
    row.style.borderBottomColor = 'transparent';
    setTimeout(function () {
      if (row.parentNode && row.classList.contains('is-removing')) row.parentNode.removeChild(row);
    }, 240);
  }

  function moveFocusFrom(row, goneKeys) {
    if (!row.contains(document.activeElement)) return;
    var next = liveRows().filter(function (r) { return goneKeys.indexOf(keyOf(r)) === -1; })[0];
    var target = next ? next.querySelector('.vcp-line__title') : els.checkout;
    if (target && target.focus) target.focus();
  }

  function afterLocalChange() {
    var left = liveRows();
    if (!left.length) showEmpty(true);
    if (els.phone) {
      els.phone.hidden = !left.some(function (r) { return r.getAttribute('data-freight') === '1'; });
    }
  }

  function showEmpty(on) {
    if (els.empty) els.empty.hidden = !on;
    if (els.form) els.form.hidden = on;
    root.classList.toggle('is-empty', on);
    syncBar();
  }

  function showErr(row, msg) {
    var n = row.querySelector('[data-vcp-err]');
    if (!n) return;
    n.textContent = msg;
    clearTimeout(n.__t);
    n.__t = setTimeout(function () { n.textContent = ''; }, 6000);
  }
  function clearErr(row) {
    var n = row.querySelector('[data-vcp-err]');
    if (n) n.textContent = '';
  }

  function reconcileGifts() {
    var products = liveRows().filter(function (r) { return kindOf(r) === 'product'; });
    var updates = {};
    liveRows().forEach(function (r) {
      if (kindOf(r) !== 'gift') return;
      var parent = r.getAttribute('data-gift-with');
      if (Number(r.getAttribute('data-price')) > 0 ||
          !products.some(function (p) { return p.getAttribute('data-variant') === parent; })) updates[keyOf(r)] = 0;
    });
    if (!Object.keys(updates).length) return;
    Object.keys(updates).forEach(function (k) { removing[k] = true; var r = rowByKey(k); if (r) collapse(r); });
    afterLocalChange();
    enqueue(function () { return send(updates, []); });
  }

  function patch(html, force) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-vcp-root]');
    if (!fresh) throw new Error('vcp: no root in section response');

    ['data-count', 'data-total', 'data-freight'].forEach(function (a) {
      root.setAttribute(a, fresh.getAttribute(a) || '');
    });
    var freshCart = readInlineCart(fresh);
    if (freshCart) lastCart = freshCart;

    fresh.querySelectorAll('[data-vcp-swap]').forEach(function (fp) {
      if (fp.closest('[data-vcp-row]')) return;
      var name = fp.getAttribute('data-vcp-swap');
      root.querySelectorAll('[data-vcp-swap="' + name + '"]').forEach(function (lp) {
        if (!lp.closest('[data-vcp-row]')) lp.replaceWith(importNode(fp));
      });
    });

    patchLines(fresh.querySelector('[data-vcp-lines]'), force);

    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    showEmpty(count === 0);

    var fPhone = fresh.querySelector('[data-vcp-phone]');
    if (els.phone && fPhone) els.phone.hidden = fPhone.hasAttribute('hidden');

    if (Object.keys(removing).length) afterLocalChange();

    updateAffirm();
    syncBar();
    announce('Cart updated');
  }

  function patchLines(freshLines, force) {
    if (!freshLines || !els.lines) return;
    var current = {};
    liveRows().forEach(function (r) { current[keyOf(r)] = r; });

    var prev = null;
    Array.prototype.forEach.call(freshLines.children, function (fr) {
      if (!fr.hasAttribute('data-vcp-row')) return;
      var k = keyOf(fr);
      if (removing[k]) return;
      var el = current[k];
      if (el) {
        delete current[k];
        patchRow(el, fr, force);
      } else {
        rows().forEach(function (r) { if (keyOf(r) === k) r.parentNode.removeChild(r); });
        el = importNode(fr);
        mountExtend(el);
      }
      place(el, prev);
      prev = el;
    });

    Object.keys(current).forEach(function (k) { collapse(current[k]); });
  }

  function place(el, prev) {
    var target = prev ? prev.nextElementSibling : els.lines.firstElementChild;
    while (target && target !== el &&
      (target.classList.contains('is-removing') || target.classList.contains('vcp-line--ghost'))) {
      target = target.nextElementSibling;
    }
    if (target !== el) els.lines.insertBefore(el, target);
  }

  function patchRow(el, fr, force) {
    var k = keyOf(el);
    var keep = busyKey(k);
    var qtyInput = el.querySelector('[data-vcp-qty]');
    var typing = qtyInput && document.activeElement === qtyInput;
    var ae = document.activeElement;
    var focusedStep = el.contains(ae) && ae.getAttribute ? ae.getAttribute('data-vcp-step') : null;

    ['data-qty', 'data-price', 'data-freight', 'data-openbox', 'data-type', 'data-gift-with', 'data-covers'].forEach(function (a) {
      if (fr.hasAttribute(a)) el.setAttribute(a, fr.getAttribute(a)); else el.removeAttribute(a);
    });
    el.className = fr.className;
    if (keep) el.classList.add('is-pending');

    fr.querySelectorAll('[data-vcp-swap]').forEach(function (fp) {
      var name = fp.getAttribute('data-vcp-swap');
      if (name === 'qty' && !force && (keep || typing)) return;
      var lp = el.querySelector('[data-vcp-swap="' + name + '"]');
      if (lp) lp.replaceWith(importNode(fp));
    });
    if (focusedStep) {
      var nb = el.querySelector('[data-vcp-step="' + focusedStep + '"]');
      if (nb) nb.focus();
    }

    var fInfo = fr.querySelector('.vcp-line__info');
    var lInfo = el.querySelector('.vcp-line__info');
    if (fInfo && lInfo && fInfo.innerHTML !== lInfo.innerHTML) lInfo.replaceWith(importNode(fInfo));

    var fP = fr.querySelector('[data-vcp-protect]');
    var lP = el.querySelector('[data-vcp-protect]');
    if (fP && lP) {
      var fs = fP.getAttribute('data-state');
      var ls = lP.getAttribute('data-state');
      if (fs === 'plan') {
        if (ls !== 'plan' || fP.innerHTML !== lP.innerHTML) lP.replaceWith(importNode(fP));
      } else if (fs !== ls) {
        lP.replaceWith(importNode(fP));
        mountExtend(el);
      }
    } else if (fP && !lP) {
      el.appendChild(importNode(fP));
      mountExtend(el);
    } else if (!fP && lP) {
      lP.parentNode.removeChild(lP);
    }
  }

  function extendReady() {
    var E = window.Extend;
    return !!(E && window.ExtendShopify && E.integration && E.buttons && window.Shopify &&
      Shopify.currency && Shopify.currency.active === E.integration.currency);
  }

  function mountExtend(scope) {
    if (!extendReady() || !window.Extend.integration.cartOffer) return;
    scope.querySelectorAll('[data-vcp-protect][data-state="offer"]').forEach(function (slot) {
      if (slot.getAttribute('data-mounted')) return;
      var row = slot.closest('[data-vcp-row]');
      if (!row) return;
      slot.setAttribute('data-mounted', '1');
      var vid = row.getAttribute('data-variant');
      var box = document.createElement('div');
      box.className = 'vcp-extend';
      slot.appendChild(box);

      Promise.resolve()
        .then(function () { return ExtendShopify.getBundleComponents({ variantId: 'gid://shopify/ProductVariant/' + vid }); })
        .catch(function () { return null; })
        .then(function (bundle) {
          var isBundle = !!(bundle && bundle.components && bundle.components.length);
          var opts = isBundle
            ? { referenceId: vid, products: bundle.components }
            : { referenceId: vid, price: Number(row.getAttribute('data-price')), category: row.getAttribute('data-type') };
          opts.onAddToCart = function (o) { addPlan(row, o); };
          Extend.buttons.renderSimpleOffer(box, opts);
        })
        .catch(function (e) { console.error('EXTEND:', e); });
    });
  }

  function addPlan(row, o) {
    enqueue(function () {
      var k = keyOf(row);
      var qty = pending[k] != null ? pending[k] : (parseInt(row.getAttribute('data-qty'), 10) || 1);
      return new Promise(function (resolve) {
        ExtendShopify.addPlanToCart({ plan: o.plan, product: o.product, products: o.products, quantity: qty }, function (err) {
          if (err) console.error('EXTEND:', err);
          resolve();
        });
      }).then(function () {
        return post('cart/update.js', { updates: {} }).then(function (d) { return apply(d, ++seq); }, function () { return refresh(); });
      });
    });
  }

  var normalizedAt = -1;
  function normalize(cart, mine) {
    if (!extendReady() || !cart || !cart.items || window.Extend.integration.cartSP) return Promise.resolve();
    if (normalizedAt === mine) return Promise.resolve();
    return withTimeout(new Promise(function (resolve) {
      try {
        ExtendShopify.normalizeCart({ cart: cart, balance: window.Extend.integration.cartBalancing }, function (err, data) {
          if (err || !data || !data.updates || normalizedAt === mine) return resolve();
          normalizedAt = mine;
          refresh().then(resolve, resolve);
        });
      } catch (e) {
        console.error('EXTEND:', e);
        resolve();
      }
    }), NORMALIZE_WAIT_MS).catch(function () {});
  }

  function whenExtend(fn) {
    var ok = false, tries = 0, t = null;
    function check() {
      clearTimeout(t);
      if (ok) return;
      if (extendReady()) { ok = true; return fn(); }
      if (++tries <= 30) t = setTimeout(check, 200);
    }
    check();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { tries = 0; check(); }, { once: true });
    }
  }

  function initRecs() {
    var sec = root.querySelector('[data-vcp-recs]');
    if (!sec) return;
    var track = sec.querySelector('[data-vcp-recs-track]');
    if (!track || sec.getAttribute('data-mode') !== 'fetch') return;

    var need = Math.min(4, track.querySelectorAll('[data-vcp-rec]').length);
    var done = false;
    function reveal() {
      if (done) return;
      done = true;
      track.classList.remove('is-loading');
      track.classList.add('is-in');
    }
    var t = setTimeout(reveal, RECS_WAIT_MS);
    var url = BASE + 'recommendations/products?section_id=voro-cart-recs&limit=10&intent=related&product_id=' +
      encodeURIComponent(sec.getAttribute('data-anchor'));

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (done || !html || !need) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = Array.prototype.slice.call(doc.querySelectorAll('[data-vcp-recs-result] [data-vcp-rec]'));
        var take = Math.min(4, cards.length);
        if (Math.ceil(take / 2) !== Math.ceil(need / 2)) take = need;
        if (cards.length >= take && take >= need) {
          track.innerHTML = '';
          cards.slice(0, take).forEach(function (c) { track.appendChild(importNode(c)); });
        }
      })
      .catch(function () {})
      .then(function () { clearTimeout(t); reveal(); });
  }

  function addRec(btn) {
    if (btn.classList.contains('is-busy') || btn.classList.contains('is-added')) return;
    var label = btn.querySelector('.vcp-rec__label') || btn;
    btn.classList.add('is-busy');
    label.textContent = 'Adding…';
    var ghost = null;
    if (els.lines && els.form && !els.form.hidden) {
      ghost = document.createElement('div');
      ghost.className = 'vcp-line vcp-line--ghost';
      ghost.setAttribute('aria-hidden', 'true');
      els.lines.insertBefore(ghost, els.lines.firstChild);
    }
    function dropGhost() { if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost); }
    enqueue(function () {
      var mine = ++seq;
      return post('cart/add.js', { items: [{ id: Number(btn.getAttribute('data-vcp-add')), quantity: 1 }] })
        .then(function (data) {
          btn.classList.remove('is-busy');
          btn.classList.add('is-added');
          btn.setAttribute('aria-disabled', 'true');
          label.textContent = 'Added';
          var html = data && data.sections && data.sections[SECTION];
          if (html) { dropGhost(); patch(html); return normalize(lastCart, mine); }
          return fetchSection().then(function (h) { dropGhost(); patch(h); });
        }, function (err) {
          dropGhost();
          btn.classList.remove('is-busy');
          btn.classList.add('is-error');
          label.textContent = 'Could not add';
          announce((err && err.message) || 'Could not add that item.');
          setTimeout(function () {
            btn.classList.remove('is-error');
            label.textContent = 'Add to cart';
          }, 2500);
        });
    });
  }

  function updateAffirm() {
    var el = root.querySelector('[data-vcp-affirm]');
    if (!el) return;
    var total = root.getAttribute('data-total') || '0';
    if (el.getAttribute('data-amount') === total) return;
    el.setAttribute('data-amount', total);
    try {
      if (window.affirm && affirm.ui && affirm.ui.ready) {
        affirm.ui.ready(function () { if (affirm.ui.refresh) affirm.ui.refresh(); });
      }
    } catch (e) {}
  }

  function saveAttr(body) {
    return fetch(BASE + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function savePhone() {
    if (!els.phoneInput) return;
    var v = els.phoneInput.value.trim();
    if (v === savedPhone) return;
    savedPhone = v;
    saveAttr({ attributes: { 'Backup phone': v } }).catch(function () { savedPhone = null; });
  }

  function saveNote() {
    if (!els.note) return;
    var v = els.note.value;
    if (v === savedNote) return;
    savedNote = v;
    saveAttr({ note: v }).catch(function () { savedNote = null; });
  }

  function initBar() {
    if (!els.bar || !els.checkout || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      barWanted = !entries[entries.length - 1].isIntersecting;
      syncBar();
    }, { rootMargin: '-' + HEADER_CLEARANCE_PX + 'px 0px 0px 0px' }).observe(els.checkout);
    if (BAR_MQ) {
      if (BAR_MQ.addEventListener) BAR_MQ.addEventListener('change', syncBar);
      else if (BAR_MQ.addListener) BAR_MQ.addListener(syncBar);
    }
  }

  function syncBar() {
    if (!els.bar) return;
    var empty = root.classList.contains('is-empty');
    var on = barWanted && (!BAR_MQ || BAR_MQ.matches) && !empty;
    els.bar.hidden = empty;
    els.bar.classList.toggle('is-on', on);
    if (on) els.bar.removeAttribute('inert'); else els.bar.setAttribute('inert', '');
    document.documentElement.classList.toggle('vcp-bar-on', on);
  }

  function idle() {
    return new Promise(function (resolve) {
      (function check() {
        if (isIdle()) return resolve(true);
        setTimeout(check, 50);
      })();
    });
  }

  function onSubmit(e) {
    if (submitting) return;
    if (waiting) { e.preventDefault(); return; }
    if (isIdle()) return;
    e.preventDefault();
    waiting = true;
    var submitter = e.submitter && e.submitter.form === els.form ? e.submitter : els.checkout;
    flushPending();
    Promise.race([idle(), new Promise(function (r) { setTimeout(function () { r(false); }, SUBMIT_WAIT_MS); })])
      .then(function (ok) {
        waiting = false;
        if (!ok) { hardReload(); return; }
        submitting = true;
        if (els.form.requestSubmit && submitter) {
          els.form.requestSubmit(submitter);
        } else {
          var h = document.createElement('input');
          h.type = 'hidden';
          h.name = 'checkout';
          h.value = '1';
          els.form.appendChild(h);
          els.form.submit();
        }
      });
  }

  function bind() {
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var step = t.closest('[data-vcp-step]');
      if (step) {
        var row = step.closest('[data-vcp-row]');
        var input = row && row.querySelector('[data-vcp-qty]');
        if (row && input) {
          var cur = parseInt(input.value, 10);
          if (!isFinite(cur)) cur = parseInt(row.getAttribute('data-qty'), 10) || 0;
          setQty(row, cur + Number(step.getAttribute('data-vcp-step')));
        }
        return;
      }
      var rm = t.closest('[data-vcp-remove]');
      if (rm) { removeRow(rm.closest('[data-vcp-row]')); return; }
      var rp = t.closest('[data-vcp-remove-plan]');
      if (rp) { removePlan(rp.closest('[data-vcp-plan]')); return; }
      var add = t.closest('[data-vcp-add]');
      if (add) { addRec(add); return; }
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-vcp-qty]')) {
        var row = t.closest('[data-vcp-row]');
        if (row) setQty(row, t.value);
      } else if (t === els.phoneInput) {
        savePhone();
      } else if (t === els.note) {
        saveNote();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || !e.target || e.target.tagName !== 'INPUT') return;
      e.preventDefault();
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (els.note) els.note.addEventListener('blur', saveNote);
    if (els.form) els.form.addEventListener('submit', onSubmit);

    window.addEventListener('pageshow', function (e) {
      submitting = false;
      waiting = false;
      if (e.persisted) enqueue(function () { return refresh(true).then(reconcileGifts); });
    });
  }

  function init() {
    bind();
    initRecs();
    initBar();
    reconcileGifts();
    whenExtend(function () {
      mountExtend(root);
      enqueue(function () { return normalize(lastCart, 0); });
    });
  }

  init();
})();
